var scope_0 = require('/home/runner/work/thedataguy.blog/thedataguy.blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ec45bd750894de651f3e0d70e992632b.js').default;
var scope_1 = require('/home/runner/work/thedataguy.blog/thedataguy.blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f2130fabbe881e1ea0e1b44095698a72.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    